import axios from 'axios';
import { Constant } from '@/config/constants';

// Set base URL
axios.defaults.baseURL = Constant.API_URL;

// Define public endpoints that should not include auth tokens
const publicEndpoints = [
    '/duck/',
    '/duck-found/',
    '/get-cruise-info-from-duck/',
    Constant.GET_DUCKS_AND_CRUISE_BY_UUID,
    Constant.GET_DUCK_BY_UUID,
    Constant.PACKAGES,
];

const isTokenExpired = (token: string): boolean => {
    try {
        const payload = token.split('.')[1];
        if (!payload) return true;

        const decoded = JSON.parse(atob(payload));
        return decoded.exp * 1000 < Date.now();
    } catch (error) {
        console.error('Unable to decode token payload:', error);
        return true;
    }
};

// Request interceptor
axios.interceptors.request.use(
    (config) => {
        // Check if the URL is a public endpoint
        const isPublicEndpoint = publicEndpoints.some(endpoint => {
            if (config.url && config.url.includes('/auth/')) {
                return false;
            }
            return config.url && config.url.includes(endpoint);
        });
            
        
        // Only add token if not a public endpoint
        if (!isPublicEndpoint) {
            const token = localStorage.getItem('token');
            if (token) {
                if (isTokenExpired(token)) {
                    localStorage.removeItem('token');
                } else {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            }
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axios;
